<template>
    <auth-layout-content :title="$t(signupTitleCode, { caller })" :message="message" :hasRightSide="!invitationToken">
        <template #subtitle>
            <span>{{ $t('pages.auth.signup.subtitle') }}</span>
            <router-link :to="{ name: RoutesEnum.AUTH.LOGIN }">&nbsp;{{ $t('pages.auth.signup.sign_in') }}</router-link>
        </template>

        <template #left-side>
            <sign-up-form :invitationToken="invitationToken" :email="email" @success="showSuccessMessage"></sign-up-form>
        </template>

        <template v-if="!invitationToken && showGSignupButton()" #right-side>
            <google-signup-component></google-signup-component>
        </template>
    </auth-layout-content>
</template>

<script>
    import AuthLayoutContent from 'components/layouts/layout-content/AuthLayoutContent'
    import SignUpForm from 'components/forms/auth/SignUpForm'
    import GoogleSignupComponent from 'components/page-elements/auth/google/GoogleSignupComponent'
    import RoutesEnum from 'enums/routes.enum'
    import AuthService from '../../services/AuthService'

    export default {
        components: { AuthLayoutContent, SignUpForm, GoogleSignupComponent },

        data: () => ({
            RoutesEnum,
            message: null,
            invitationToken: null,
            caller: null,
            email: null,
            signupTitleCode: 'pages.auth.signup.title',
        }),

        methods: {
            showSuccessMessage() {
                this.message = {
                    text: this.$t(`pages.auth.signup.messages.${this.invitationToken ? 'invite' : 'register'}_success`),
                    type: 'success',
                }
            },

            showGSignupButton() {
                return !navigator.userAgent.includes('Instagram') && !navigator.userAgent.match(/FBAN|FBAV/i)
            },
        },

        mounted() {
            if (AuthService.isSubdomainActive()) {
                AuthService.reloadSubdomainCompany()
            }
            const invitationTokenQueryParam = this.$route.query['token']
            if (invitationTokenQueryParam) {
                this.invitationToken = invitationTokenQueryParam
                this.caller = this.$route.query['caller']
                this.email = this.$route.query['email']
                this.signupTitleCode = 'pages.auth.signup.invitation_title'
            }
        },
    }
</script>
